// extracted by mini-css-extract-plugin
module.exports = {"callToBookSection":"callToBookSection_callToBookSection__2g2-Y","iconFooter":"callToBookSection_iconFooter__swU1E"};